<template>
  <div
    :class="[
      'dns-providers-item',
      {
        'dns-providers-item--completed': value.completed,
      },
    ]"
  >
    <div class="dns-providers-item__label">
      <Icon :icon="`fa-pro-solid:circle-${order + 1}`" />
      <div v-html="value.content"></div>
    </div>
    <div v-if="$path('items.length', value)" class="dns-providers-item__items">
      <ul>
        <li v-for="item in value.items" class="dns-providers-item__li">
          <span>{{ item.content || item }}</span>
          <span class="dns-providers-item__li-target" v-if="item.target" @click="copy(item.target)">
            <span>{{ item.target }}</span>
            <Icon icon="fa-regular:copy" />
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { CopyToClipboard } from '@/utils'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    order: Number,
  },

  methods: {
    copy(value) {
      CopyToClipboard(value)
    },
    getIcon(value) {
      if (value) return 'circle-check'
      return 'circle-exclamation'
    },
  },
}
</script>

<style lang="scss">
.dns-providers-item {
  &__label {
    background-color: var(--light-grey);
    padding: 1rem;
    border-radius: var(--border-radius);
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
  &--completed {
    .dns-providers-item__label {
      background-color: var(--secondary);
    }
  }
  &__li {
    &-target {
      display: inline-flex;
      gap: 0.3em;
      cursor: pointer;
      &:active {
        opacity: 0.7;
      }
      span {
        font-weight: bold;
        text-decoration: underline;
        text-underline-offset: 2px;
        margin-left: 0.3em;
      }
      svg {
        color: var(--dark-grey);
        height: 0.9rem;
      }
    }
  }
}
</style>
